export default "__VITE_ASSET__lpv8kbRA__"